import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../hooks/useApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔍 Check existing session
  useEffect(() => {
    const token = localStorage.getItem("nr_token");

    if (!token) {
      setLoading(false);
      return;
    }

    api
      .getMe()
      .then((res) => {
        if (!res.data?.user) {
          throw new Error("Invalid session");
        }
        setUser(res.data.user);
      })
      .catch(() => {
        localStorage.removeItem("nr_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  // 🔐 LOGIN (STRICT + SAFE)
  const login = async (email, password) => {
    try {
      const res = await api.login({ email, password });

      const { token, user, message } = res.data;

      // 🚨 HARD VALIDATION
      if (!token || !user) {
        throw new Error(message || "Login failed");
      }

      // ✅ Save valid token only
      localStorage.setItem("nr_token", token);
      setUser(user);

      return user;
    } catch (err) {
      // 🔴 Normalize error message
      const errorMessage =
        err.response?.data?.message || err.message || "Something went wrong";

      throw new Error(errorMessage);
    }
  };

  // 🚪 LOGOUT
  const logout = () => {
    localStorage.removeItem("nr_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        isAdmin: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

// 🔌 Hook
export const useAuth = () => useContext(AuthContext);
